import { serviceReduxConstants } from '@/constants';
import { ServiceCategory } from '@/types/services';

export type ServiceCategoriesState = {
  ids: Array<number>;
  all: {
    [id: number]: ServiceCategory;
  };
};

export function serviceCategories(
  state: ServiceCategoriesState = { ids: [], all: {} },
  action: { type: string; payload?: ServiceCategoriesState; payloadService?: ServiceCategory },
): ServiceCategoriesState {
  switch (action.type) {
    case serviceReduxConstants.SET_SERVICE_CATEGORIES:
      return {
        ids: [...state.ids, ...action.payload.ids],
        all: {
          ...state.all,
          ...action.payload.all,
        },
      };

    default:
      return state;
  }
}
